import React, { useState, useReducer, useEffect, useRef } from 'react'
import { hot } from 'react-hot-loader'

import TextField from '@ui-library/core/TextField'
import Dropdown from '@ui-library/core/Dropdown'
import Button from '@ui-library/core/Button'

import { PICTURES } from './pictures'

import {
  ErrorMessage,
  SliceRegie,
  LogoRegie,
  LinkButton,
  FormGrid,
  StyledH2,
  StyledH3,
  StyledTextArea,
  FormulaireContactH3,
  RequiredInfo,
  FormulaireContact,
  FormButtonContainer,
  StyledTitle,
  MainContainer,
  Wrapper,
  AccordionContent,
  Main,
  ContactUsContent,
  StyledAccordion,
  Banner,
  BannerContent,
  BannerSubtitle,
  BannerTitle,
  BannerMessageContainer,
  BannerText,
  SuccessMessage,
} from './Contact.styled'

import { websiteSelectList, professionalSelectList, getSubReason, getReason, getSubjectText } from './contactUtils'

const initialFormState = {
  name: '',
  email: '',
  description: '',
  subjectElement: null,
}

const formReducer = (state, action) => {
  switch (action.type) {
    case 'HANDLE INPUT':
      return {
        ...state,
        [action.field]: action.payload,
      }
    case 'reset':
      return initialFormState
    default:
      return state
  }
}

const Contact = () => {
  const [showMore, setShowMore] = useState(false)
  const [bannerMessage, setBannerMessage] = useState(null)
  const [successMessage, setSuccessMessage] = useState(null)
  const [qsListingId, setqsListingId] = useState(null)
  const [accordionState, setAccordionState] = useState({
    accountTitle: false,
    account: false,
    coordinates: false,
    password: false,
    cantAccessAccount: false,
    accountToDelete: false,
    myData: false,
    searchingHelp: false,
    seekClassfied: false,
    websiteDown: false,
    visit: false,
    noReturnFromAgency: false,
    noAnswerToMyCalls: false,
    alertsNotExpected: false,
    stopAlerts: false,
    classified: false,
    email: false,
    fakeClassified: false,
    signalClassified: false,
    fakePhone: false,
    noPermission: false,
    publish: false,
    professional: false,
    informations: false,
    proPublish: false,
    advert: false,
    media: false,
    editorial: false,
  })
  const [accordionRubricState, setAccordionRubricState] = useState({
    accountTitle: false,
    searchingHelp: false,
    classified: false,
    trustSecurity: false,
  })

  const [formulaireContactState, setFormVisible] = useState(false)
  const [disabled, setDisabledFormBtn] = useState(false)
  const formRef = useRef(null)

  const handleAccordionChange = value => {
    setAccordionState({ ...accordionState, [value]: !accordionState[value] })
  }

  const handleAccordionRubricChange = value => {
    setAccordionRubricState({ ...accordionRubricState, [value]: !accordionRubricState[value] })
  }

  const [formState, dispatch] = useReducer(formReducer, initialFormState)
  useEffect(() => {
    const queryString = window.location.search
    // Si on a query=legal dans l'url on séléctionne d'office l'objet RGPD
    if (/\?query=legal/.test(queryString)) {
      dispatch({ type: 'HANDLE INPUT', field: 'subjectElement', payload: 8 })
    }

    // Si on a query=fraude dans l'url on séléctionne d'office l'objet Fraude
    if (/\?query=fraude/.test(queryString)) {
      dispatch({ type: 'HANDLE INPUT', field: 'subjectElement', payload: 8 })
    }
    // On récupère l'id de l'annonce pour déclarer une fraude
    if (queryString.indexOf('listingId') !== -1) {
      const split = queryString.split('&')

      split.forEach(param => {
        if (param.indexOf('listingId=') !== -1) {
          setqsListingId(param.split('=')[1])
        }
      })
    }
  }, [])

  const handleSelect = value => {
    dispatch({
      type: 'HANDLE INPUT',
      field: 'subjectElement',
      payload: value,
    })
  }

  const handleChange = ({ target: { name, value } }) => {
    dispatch({
      type: 'HANDLE INPUT',
      field: name,
      payload: value,
    })
  }
  const handleClickHere = () => {
    setShowMore(!showMore)
  }

  const handleDisplayForm = () => {
    dispatch({ type: 'reset' })
    setSuccessMessage(null)
    setDisabledFormBtn(false)
  }

  const validateForm = ({ name, email, description, subjectElement }) => {
    if (name.length < 2) {
      setBannerMessage({ message: 'Merci de bien vouloir nous indiquer votre nom' })
      return true
    }

    if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email)) {
      setBannerMessage({ message: 'Merci de bien vouloir nous indiquer une adresse email valide' })
      return true
    }

    if (subjectElement === null) {
      setBannerMessage({ message: "Merci de bien vouloir nous indiquer l'objet de votre demande" })
      return true
    }

    if (description.length < 5) {
      setBannerMessage({ message: 'Votre message doit contenir au minimum 5 caractères' })
      return true
    }
    setBannerMessage(null)
    return false
  }

  const handleSendMessage = () => {
    setDisabledFormBtn(true)
    const error = validateForm(formState)
    if (!error) {
      const data = {
        name: formState.name,
        email: formState.email,
        description: formState.description,
        subject: getSubjectText(formState.subjectElement),
        reason: getReason(formState.subjectElement),
        subReason: getSubReason(formState.subjectElement),
        listingId: qsListingId,
      }
      fetch('/ser/api/Partner/contact', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }).then(res => {
        if (res.status === 200) {
          setSuccessMessage({ message: 'Votre message a bien été envoyé' })
        } else {
          setBannerMessage({ message: 'Une erreur est survenue merci de reessayer ulterieurement' })
        }
      })
    } else {
      setDisabledFormBtn(false)
    }
  }

  const handleAnchor = value => {
    setFormVisible(true)
    setTimeout(() => {
      formRef.current.scrollIntoView()
      dispatch({ type: 'HANDLE INPUT', field: 'subjectElement', payload: value })
    }, 100)
  }

  return (
    <Main>
      <Banner>
        <BannerContent>
          <BannerMessageContainer>
            <BannerTitle>Aide & contact</BannerTitle>
            <BannerSubtitle>Vous avez une question ou une demande concernant le site internet ou l’application SeLoger ?</BannerSubtitle>
            <BannerText>Retrouvez ci-dessous toutes les informations utiles ou contactez-nous si vous ne trouvez pas la réponse a votre question</BannerText>
          </BannerMessageContainer>
        </BannerContent>
      </Banner>
      <Wrapper>
        <MainContainer>
          <h2>Particuliers</h2>
          <StyledAccordion title="COMPTE" visible={accordionRubricState.accountTitle} onClick={() => handleAccordionRubricChange('accountTitle')}>
            <StyledAccordion
              title="Je n'arrive pas à créer mon compte. Je suis bloqué sur la création de mon compte."
              visible={accordionState.account}
              onClick={() => handleAccordionChange('account')}
            >
              <AccordionContent>
                <p>Vous rencontrez des difficultés pour créer votre compte sur le site, voici quelques solutions qui peuvent vous aider :</p>
                <p>1. Videz le cache de votre navigateur</p>
                <p>Les caches de votre navigateur peuvent parfois entraîner des problèmes d&apos;affichage ou de fonctionnalité sur certains sites.</p>
                <br />
                <p>2. Mettez à jour votre navigateur</p>
                <p>Il est essentiel de maintenir votre navigateur à jour pour une meilleure compatibilité avec les sites web.</p>
                <br />
                <p>3. Essayez un autre navigateur ou appareil.</p>
                <p>
                  Si le problème persiste après avoir vidé le cache et mis à jour votre navigateur, essayez d&apos;ouvrir SeLoger sur un autre navigateur (comme Firefox, Edge ou
                  Safari) ou sur un autre appareil (comme un téléphone ou une tablette).
                </p>
                <br />
                <p>En suivant ces étapes, vous devriez pouvoir résoudre la plupart des problèmes de navigation sur le site.</p>
                <p>Si le problème persiste, il peut s&apos;agir d&apos;un problème temporaire sur le site ; dans ce cas, il est recommandé de réessayer plus tard.</p>
                <p>Vous pouvez également nous contacter pour que nous puissions vous aider à résoudre le problème.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <AccordionContent>
                <ContactUsContent>
                  <StyledTitle>Comment nous contacter</StyledTitle>
                  <p>
                    1. Rendez-vous sur notre formulaire de contact.{' '}
                    <LinkButton
                      onClick={() => {
                        handleAnchor(5)
                      }}
                    >
                      https://www.seloger.com/contact.html
                    </LinkButton>
                  </p>
                  <br />
                  <p>2. Dans le formulaire, précisez clairement le problème que vous avez rencontré.</p>
                  <p>Plus vous fournissez d&apos;informations, plus il nous sera facile de comprendre et résoudre votre problème.</p>
                  <br />
                  <p>3.Veuillez inclure les détails suivants :</p>
                  <ul>
                    <li>La page ou la fonctionnalité concernée (par exemple, la recherche de biens, l&apos;affichage des annonces, etc.)</li>
                    <li>Le navigateur que vous utilisez (Chrome, Firefox, Safari, etc.)</li>
                    <li>La version de votre navigateur et de votre système d&apos;exploitation</li>
                    <li>Une description détaillée du problème (erreur affichée, comportement étrange, etc.)</li>
                    <li>Si possible, des captures d&apos;écran qui montrent le problème (cela peut nous aider à mieux comprendre l&apos;incident).</li>
                  </ul>

                  <p>Nous nous engageons à traiter votre demande dans les plus brefs délais et à vous apporter une solution adéquate.</p>
                </ContactUsContent>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion title="Je souhaite modifier mes coordonnées." visible={accordionState.coordinates} onClick={() => handleAccordionChange('coordinates')}>
              <AccordionContent>
                <p>Vous souhaitez modifier vos coordonnées, pour cela :</p>
                <p>1. Connectez-vous à votre compte SeLoger.</p>
                <p>
                  Cliquez sur l&apos;icône « Compte » en haut à droite de la page d&apos;accueil Seloger ou suivez ce lien :{' '}
                  <a href="https://signin.seloger.com/u/login?state=hKFo2SA3dWdvQ3hCMVFyNFVRM1BRTnN3OFhmNGhfblJlSWFDc6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIERzel9qclJQalNpcUNaNWt4cVhzWnZtQzZyUjJ2M0Vho2NpZNkgVDFWSmlHUXJtVUlvVjM5bnNmZnR5RHlyTG9yVkR3UDI">
                    Cliquez ici
                  </a>{' '}
                  et saisissez vos identifiants.
                </p>
                <br />
                <p>2. Rendez-vous sur votre onglet Compte</p>
                <img src={PICTURES.myAccountScreenShot} alt="" title="" />
                <br />
                <p>3. Deux sections s&apos;offrent à vous pour modifier vos coordonnées :</p>
                <ul>
                  <li>Informations personnelles : cette section vous permet de mettre à jour votre nom, numéro de téléphone, adresse, etc.</li>
                  <li>Connexion et sécurité : cette section vous permet de modifier votre adresse e-mail et votre mot de passe.</li>
                </ul>
                <p>N&apos;oubliez pas de sauvegarder vos modifications après avoir mis à jour vos informations.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion title="Je souhaite modifier mon mot de passe." visible={accordionState.password} onClick={() => handleAccordionChange('password')}>
              <AccordionContent>
                <p>Si vous vous souvenez de votre mot de passe, connectez-vous à votre compte SeLoger.</p>
                <p>
                  1. Cliquez sur le pictogramme de compte en haut à droite de la page d’accueil de Seloger ou rendez-vous sur ce lien :{' '}
                  <a href="https://signin.seloger.com/u/login?state=hKFo2SA3dWdvQ3hCMVFyNFVRM1BRTnN3OFhmNGhfblJlSWFDc6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIERzel9qclJQalNpcUNaNWt4cVhzWnZtQzZyUjJ2M0Vho2NpZNkgVDFWSmlHUXJtVUlvVjM5bnNmZnR5RHlyTG9yVkR3UDI">
                    Cliquez ici
                  </a>{' '}
                  et saisissez vos identifiants de connexion
                </p>
                <br />
                <p>2. Dans la section “Compte” puis “Connexion et sécurité“, vous pourrez modifier votre mot de passe.</p>
                <img src={PICTURES.myAccountScreenShot} alt="" title="" />
                <img width="100%" src={PICTURES.connexionSecurity} alt="" title="" />
                <p>Si vous avez oublié votre mot de passe :</p>
                <p>1. Rendez-vous sur la page de connexion à votre compte puis cliquez sur “Mot de passe oublié“.</p>
                <img src={PICTURES.logging} alt="" title="" />
                <p>2. Suivez les instructions envoyées par e-mail pour réinitialiser votre mot de passe.</p>
                <p>(si vous ne trouvez pas notre email dans votre boîte de réception, nous vous recommandons de vérifier vos dossiers de spam ou de courriers indésirables).</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Je n'arrive pas à me connecter à mon compte."
              visible={accordionState.cantAccessAccount}
              onClick={() => handleAccordionChange('cantAccessAccount')}
            >
              <AccordionContent>
                <p>Si vous rencontrez des difficultés pour vous connecter à votre compte SeLoger, voici quelques solutions qui peuvent vous aider :</p>
                <p>1. Vérifiez vos identifiants :</p>
                <p>
                  Assurez-vous que l’adresse e-mail et le mot de passe que vous avez saisis sont corrects. Vérifiez également si vous avez activé la touche “Verr. Maj” ou un espace
                  supplémentaire accidentellement.
                </p>
                <br />
                <p>2. Réinitialiser votre mot de passe :</p>
                <p>
                  Si vous avez oublié votre mot de passe ou si vous pensez qu’il est incorrect, cliquez sur “Mot de passe oublié” après avoir cliqué sur l’onglet d’accès à votre
                  compte.
                </p>
                <p>Entrez l’adresse e-mail associée à votre compte et suivez les instructions envoyées par e-mail pour réinitialiser votre mot de passe.</p>
                <br />
                <p>3. Vérifiez votre boîte de réception et vos spams :</p>
                <p>
                  Si vous avez demandé une réinitialisation de mot de passe, assurez-vous de vérifier non seulement votre boîte de réception, mais aussi vos messages indésirables
                  (spams).
                </p>
                <br />
                <p>4. Essayez un autre navigateur ou appareil : </p>
                <p>
                  Parfois, un problème technique lié à votre navigateur ou appareil peut empêcher la connexion. Essayez avec un autre navigateur ou appareil pour vérifier si cela
                  résout le problème.
                </p>
                <br />
                <p>5. Effacer le cache et les cookies :</p>
                <p>
                  Parfois, des problèmes de connexion peuvent être causés par le cache ou les cookies de votre navigateur. Essayez de les effacer et tentez à nouveau de vous
                  connecter.
                </p>
                <p>Si, malgré ces étapes, vous n’arrivez toujours pas à vous connecter, n’hésitez pas à contacter notre support technique pour obtenir une aide supplémentaire.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <AccordionContent>
                <ContactUsContent>
                  <StyledTitle>Comment nous contacter</StyledTitle>
                  <p>
                    1. Rendez-vous sur notre formulaire de contact.{' '}
                    <LinkButton
                      onClick={() => {
                        handleAnchor(5)
                      }}
                    >
                      https://www.seloger.com/contact.html
                    </LinkButton>
                  </p>
                  <br />
                  <p>2. Dans le formulaire, précisez clairement le problème que vous avez rencontré.</p>
                  <p>Plus vous fournissez d&apos;informations, plus il nous sera facile de comprendre et résoudre votre problème.</p>
                  <br />
                  <p>3.Veuillez inclure les détails suivants :</p>
                  <ul>
                    <li>La page ou la fonctionnalité concernée (par exemple, la recherche de biens, l&apos;affichage des annonces, etc.)</li>
                    <li>Le navigateur que vous utilisez (Chrome, Firefox, Safari, etc.)</li>
                    <li>La version de votre navigateur et de votre système d&apos;exploitation</li>
                    <li>Une description détaillée du problème (erreur affichée, comportement étrange, etc.)</li>
                    <li>Si possible, des captures d&apos;écran qui montrent le problème (cela peut nous aider à mieux comprendre l&apos;incident).</li>
                  </ul>

                  <p>Nous nous engageons à traiter votre demande dans les plus brefs délais et à vous apporter une solution adéquate.</p>
                </ContactUsContent>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion title="Je souhaite supprimer mon compte." visible={accordionState.accountToDelete} onClick={() => handleAccordionChange('accountToDelete')}>
              <AccordionContent>
                <p>Pour supprimer votre compte :</p>
                <p>1. Connectez-vous à votre compte SeLoger.</p>
                <p>
                  Cliquez sur le pictogramme de compte en haut à droite de la page d’accueil de Seloger ou rendez-vous sur ce lien :{' '}
                  <a href="https://signin.seloger.com/u/login?state=hKFo2SA3dWdvQ3hCMVFyNFVRM1BRTnN3OFhmNGhfblJlSWFDc6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIERzel9qclJQalNpcUNaNWt4cVhzWnZtQzZyUjJ2M0Vho2NpZNkgVDFWSmlHUXJtVUlvVjM5bnNmZnR5RHlyTG9yVkR3UDI">
                    Cliquez ici
                  </a>{' '}
                  et saisissez vos identifiants de connexion
                </p>
                <br />
                <p>2. Rendez-vous sur votre onglet Compte puis Connexion et sécurité</p>
                <img src={PICTURES.myAccountScreenShot} alt="" title="" />
                <img width="100%" src={PICTURES.connexionSecurity} alt="" title="" />
                <br />
                <p>3. En bas de page, cliquez sur “Supprimer mon compte”</p>
                <img width="50%" src={PICTURES.deleteAccount} alt="" title="" />
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion title="Je souhaite accéder à mes données" visible={accordionState.myData} onClick={() => handleAccordionChange('myData')}>
              <AccordionContent>
                <p>Si vous souhaitez accéder à vos données, nous vous invitons à nous contacter via le formulaire de contact.</p>
                <p>
                  1. Rendez-vous sur notre formulaire de contact.{' '}
                  <LinkButton
                    onClick={() => {
                      handleAnchor(5)
                    }}
                  >
                    https://www.seloger.com/contact.html
                  </LinkButton>
                </p>
                <br />
                <p>2. Sélectionnez l&apos;option &quot;Données personnelles : exercez vos droits&quot; dans le menu déroulant.</p>
                <br />
                <p>3. Remplissez les informations demandées et soumettez votre demande.</p>
                <br />
                <p>Une fois votre demande envoyée, notre équipe traitera votre demande dans les plus brefs délais.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
          </StyledAccordion>
          <StyledAccordion title="AIDE A LA RECHERCHE" visible={accordionRubricState.searchingHelp} onClick={() => handleAccordionRubricChange('searchingHelp')}>
            <StyledAccordion title="Je cherche un bien à louer/acheter" visible={accordionState.seekClassfied} onClick={() => handleAccordionChange('seekClassfied')}>
              <AccordionContent>
                <p>Vous êtes à la recherche d’un bien, pour cela :</p>
                <p>1. Accédez à SeLoger</p>
                <p>
                  Rendez-vous sur le site <a href="www.seloger.com">www.seloger.com</a> depuis votre navigateur web.
                </p>
                <br />
                <p>2. Utilisez la barre de recherche</p>
                <p>
                  Sur la page d’accueil, vous verrez une grande barre de recherche. Entrez la localité où vous souhaitez trouver un bien (ville, quartier, code postal) dans le
                  champ prévu à cet effet.
                </p>
                <p>Si vous cherchez un bien dans plusieurs zones, vous pouvez également entrer plusieurs localités.</p>
                <br />
                <p>3. Affinez votre recherche avec des critères supplémentaires</p>
                <p>Après avoir renseigné la ville ou la localisation, vous pouvez affiner votre recherche en sélectionnant des critères supplémentaires par exemple :</p>
                <p>Type de bien : choisissez entre un appartement, une maison, un studio, etc.</p>
                <p>Budget : indiquez votre fourchette de prix (loyer ou prix d’achat).</p>
                <p>Surface : choisissez la superficie du bien souhaité.</p>
                <p>Nombre de pièces : sélectionnez le nombre de chambres ou de pièces.</p>
                <p>+ de critères : vous pouvez également filtrer selon des critères comme l’étage, la présence d’un balcon, d’un jardin, ou d’une place de parking, etc.</p>
                <br />
                <p>4. Explorez les annonces</p>
                <p>
                  Parcourez les annonces qui apparaissent sur la page des résultats. Chaque bien est affiché avec une photo, le prix, la surface et les caractéristiques
                  principales.
                </p>
                <p>Si une annonce vous intéresse, cliquez dessus pour en savoir plus (photos supplémentaires, description détaillée, informations sur le quartier, etc.).</p>
                <p>
                  Si un bien vous intéresse particulièrement, vous pouvez l’ajouter à vos “Favoris” en cliquant sur l’icône en forme de cœur. Cela vous permet de revenir facilement
                  sur les annonces que vous aimez.
                </p>
                <br />
                <p>5. Contactez l’annonceur</p>
                <p>
                  Lorsque vous avez trouvé un bien qui vous plaît, vous pouvez contacter l’agence ou le propriétaire via le formulaire de contact disponible sur l’annonce pour
                  demander plus d’informations ou planifier une visite.
                </p>
                <br />
                <p>6. Sauvergardez votre recherche</p>
                <p>Si vous souhaitez être informé des nouveaux biens correspondant à vos critères : cliquez sur ‘Créer une alerte’</p>
                <p>Vous pourrez ainsi recevoir des alertes par email dès qu’un bien correspondant à vos critères est mis en ligne.</p>
                <br />
                <p>7. Créez un compte</p>
                <p>Créez un compte gratuit sur SeLoger. Vous pourrez ainsi gérer vos alertes, retrouvez vos biens en favoris.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Le site ne fonctionne pas. La recherche n'est pas possible."
              visible={accordionState.websiteDown}
              onClick={() => handleAccordionChange('websiteDown')}
            >
              <AccordionContent>
                <p>Vous rencontrez des difficultés pour naviguer sur le site Seloger, voici quelques solutions qui peuvent vous aider :</p>
                <p>1. Vider le cache de votre navigateur</p>
                <p>Les caches de votre navigateur peuvent parfois causer des problèmes d’affichage ou de fonctionnalité sur certains sites.</p>
                <br />
                <p>2. Mettre à jour votre navigateur</p>
                <p>Il est essentiel de garder votre navigateur à jour pour une meilleure compatibilité avec les sites web.</p>
                <br />
                <p>3. Essayer un autre navigateur ou appareil</p>
                <p>
                  Si après avoir vidé le cache et mis à jour votre navigateur, le problème persiste, essayez d’ouvrir SeLoger sur un autre navigateur (comme Firefox, Edge, ou
                  Safari) ou sur un autre appareil (comme un téléphone ou une tablette).
                </p>
                <p>En suivant ces étapes, vous devriez être en mesure de résoudre la plupart des problèmes de navigation sur le site.</p>
                <p>Si le problème persiste, il peut s’agit d’un problème temporaire lié au site, auquel cas il est recommandé de réessayer plus tard.</p>
                <p>Vous pouvez également nous contacter pour que nous puissions vous aider à résoudre le problème.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <AccordionContent>
                <ContactUsContent>
                  <StyledTitle>Comment nous contacter</StyledTitle>
                  <p>
                    1. Rendez-vous sur notre formulaire de contact.{' '}
                    <LinkButton
                      onClick={() => {
                        handleAnchor(5)
                      }}
                    >
                      https://www.seloger.com/contact.html
                    </LinkButton>
                  </p>
                  <br />
                  <p>2. Dans le formulaire, précisez clairement le problème que vous avez rencontré.</p>
                  <p>Plus vous fournissez d&apos;informations, plus il nous sera facile de comprendre et résoudre votre problème.</p>
                  <br />
                  <p>3.Veuillez inclure les détails suivants :</p>
                  <ul>
                    <li>La page ou la fonctionnalité concernée (par exemple, la recherche de biens, l&apos;affichage des annonces, etc.)</li>
                    <li>Le navigateur que vous utilisez (Chrome, Firefox, Safari, etc.)</li>
                    <li>La version de votre navigateur et de votre système d&apos;exploitation</li>
                    <li>Une description détaillée du problème (erreur affichée, comportement étrange, etc.)</li>
                    <li>Si possible, des captures d&apos;écran qui montrent le problème (cela peut nous aider à mieux comprendre l&apos;incident).</li>
                  </ul>

                  <p>Nous nous engageons à traiter votre demande dans les plus brefs délais et à vous apporter une solution adéquate.</p>
                </ContactUsContent>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="J’ai vu un bien qui m’intéresse sur le site et je souhaite le visiter"
              visible={accordionState.visit}
              onClick={() => handleAccordionChange('visit')}
            >
              <AccordionContent>
                <p>Vous avez trouvé un bien qui vous intéresse sur SeLoger et souhaitez organiser une visite, voici les étapes à suivre :</p>
                <p>1. Accédez à l’annonce du bien</p>
                <p>Cliquez sur l’annonce du bien immobilier que vous souhaitez visiter.</p>
                <p>
                  Vous y trouverez toutes les informations relatives au bien, telles que les photos, la description, le prix, ainsi que les coordonnées de l’agence ou du
                  propriétaire.
                </p>
                <br />
                <p>2. Contactez l’annonceur</p>
                <p>Depuis l’annonce, vous trouverez un formulaire de contact en ligne qui vous permet d’envoyer un message directement à l’annonceur pour demander une visite.</p>
                <p>Vous pourrez également accéder au téléphone en cliquant sur ‘Afficher le numéro’</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="J’ai contacté une agence/un propriétaire mais je n’ai pas de retour à mes demandes"
              visible={accordionState.noReturnFromAgency}
              onClick={() => handleAccordionChange('noReturnFromAgency')}
            >
              <AccordionContent>
                <p>Il peut arriver que les annonceurs prennent un certain temps pour répondre à vos demandes, notamment si le bien est très demandé.</p>
                <p>Si vous n’avez pas reçu de retour après avoir contacté un annonceur, voici quelques conseils à suivre :</p>
                <p>1. Vérifiez les délais de réponse</p>
                <p>
                  Gardez à l’esprit que les annonceurs peuvent parfois être occupés, ce qui peut entraîner des délais de réponse plus longs. Patientez un peu, surtout si vous avez
                  contacté l’annonce récemment.
                </p>
                <br />
                <p>2. Relancez votre demande</p>
                <ul>
                  <li>Si vous n’avez pas reçu de réponse après quelques jours, il peut être utile de relancer votre demande.</li>
                  <li>
                    Si vous avez effectué un contact par téléphone, n’hésitez pas à essayer de faire un contact via le formulaire présent sur le détail de l’annonce ou inversement
                  </li>
                </ul>
                <br />
                <p>3. Essayez de contacter d’autres biens similaires</p>
                <br />
                <p>Si vous ne parvenez toujours pas à obtenir une réponse, il est judicieux de chercher des biens similaires.</p>
                <p>Vous pouvez contacter plusieurs propriétaires ou agences afin d’augmenter vos chances de trouver rapidement un bien qui vous correspond.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="L’agence ne répond pas à mes appels, avez-vous un autre numéro ?"
              visible={accordionState.noAnswerToMyCalls}
              onClick={() => handleAccordionChange('noAnswerToMyCalls')}
            >
              <AccordionContent>
                <p>Nous comprenons que cela puisse être frustrant, mais nous ne disposons malheureusement pas d’un autre numéro pour contacter l’agence.</p>
                <p>Le numéro affiché sur l’annonce est le seul que nous avons à disposition.</p>
                <p>Voici quelques conseils pour tenter de résoudre cette situation :</p>
                <p>1. Essayez à nouveau plus tard</p>
                <p>
                  Les agences immobilières peuvent être très sollicitées, surtout pendant les heures de forte affluence. Nous vous conseillons de réessayer à un autre moment de la
                  journée, notamment en dehors des heures de pointe.
                </p>
                <br />
                <p>2. Envoyez un message via le formulaire de contact</p>
                <p>
                  Si vous ne parvenez toujours pas à joindre l’agence par téléphone, nous vous recommandons d’envoyer un message via le formulaire de contact disponible sur
                  l’annonce.
                </p>
                <p>De cette manière, vous pouvez exprimer clairement votre intérêt pour le bien et demander un rendez-vous ou plus d’informations.</p>
                <br />
                <p>3. Consulter d’autres biens similaires</p>
                <br />
                <p>
                  Si la situation persiste, vous pouvez également rechercher des biens similaires sur notre site et contacter d’autres agences qui pourraient avoir des annonces
                  correspondant à vos critères.
                </p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="J’ai créé une alerte mais je reçois des annonces qui ne correspondent pas à mes critères"
              visible={accordionState.alertsNotExpected}
              onClick={() => handleAccordionChange('alertsNotExpected')}
            >
              <AccordionContent>
                <p>Nous comprenons que cela puisse être irritant de recevoir des annonces qui ne correspondent pas à vos attentes.</p>
                <p>Voici ce que nous vous conseillons de faire :</p>
                <p>1. Vérifiez les critères de votre alerte enregistrée</p>
                <p>
                  Accédez à l’alerte que vous avez créée et vérifiez que tous les critères (prix, type de bien, localisation, superficie, nombre de pièces, etc.) sont correctement
                  définis.
                </p>
                <p>Assurez-vous que les informations saisies correspondent bien à vos préférences.</p>
                <br />
                <p>2. Ajustez les critères de votre alerte si nécessaire</p>
                <p>
                  Si nous ne trouvons pas suffisamment de biens correspondant à vos critères exacts, nous allons légèrement élargir les critères afin de vous envoyer des annonces
                  qui s’en rapprochent au mieux.
                </p>
                <p>
                  Cela peut concerner le prix, la superficie, ou la localisation. Par exemple, si vous avez sélectionné un budget très précis, il est possible que certains biens
                  légèrement au-dessus ou en dessous de ce budget soient pertinents
                </p>
                <br />
                <p>3. Créez une nouvelle alerte si nécessaire</p>
                <br />
                <p>
                  Si après avoir vérifié vos critères, vous continuez à recevoir des annonces qui ne correspondent toujours pas, vous pouvez essayer de supprimer l’alerte actuelle
                  et de créer une nouvelle alerte avec des critères réajustés
                </p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Je souhaite me désinscrire de mon alerte. Je ne souhaite plus recevoir d’ annonces."
              visible={accordionState.stopAlerts}
              onClick={() => handleAccordionChange('stopAlerts')}
            >
              <AccordionContent>
                <p>Vous souhaitez désactiver votre alerte et ne plus recevoir d’annonces, voici la procédure à suivre :</p>
                <p>1. Notifications par e-mails :</p>
                <p>Pour cela, c’est très simple, il vous suffit de reprendre votre dernière alerte reçue et vous trouverez en bas de page, un lien “Arrêter cette alerte”</p>
                <img width="50%" src={PICTURES.stopAlerts} alt="" title="" />
                <p>Si vous ne disposez plus de l’e-mail, nous vous invitons à vous rendre directement sur votre compte.</p>
                <p>
                  Cliquez sur le pictogramme de compte en haut à droite de la page d’accueil de Seloger ou rendez-vous sur ce lien :{' '}
                  <a href="https://signin.seloger.com/u/login?state=hKFo2SA3dWdvQ3hCMVFyNFVRM1BRTnN3OFhmNGhfblJlSWFDc6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIERzel9qclJQalNpcUNaNWt4cVhzWnZtQzZyUjJ2M0Vho2NpZNkgVDFWSmlHUXJtVUlvVjM5bnNmZnR5RHlyTG9yVkR3UDI">
                    Cliquez Ici
                  </a>{' '}
                  et saisissez vos identifiants de connexion
                </p>
                <p>
                  Une fois connecté, rendez-vous sur la rubrique “Mes alertes”, vous retrouverez alors l’ensemble de vos alertes créées que vous pourrez désactiver ou réactiver à
                  tout moment.
                </p>
                <img width="100%" src={PICTURES.alerts} alt="" title="" />
                <br />
                <p>2. Notifications depuis votre mobile :</p>
                <p>Il vous suffit de vous rendre sur votre compte depuis l’application.</p>
                <p>
                  Accédez à la rubrique “Gérer mes abonnements” puis rendez-vous sur “Alertes et notifications”, vous retrouverez alors l’ensemble de vos alertes créées que vous
                  pourrez désactiver ou réactiver à tout moment.
                </p>
                <img width="35%" src={PICTURES.myAccount} alt="" title="" />
                <p>Ainsi vous ne recevrez plus d’alertes immobilières sous un délai de 24h.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
          </StyledAccordion>
          <StyledAccordion title="CONFIANCE ET SECURITE" visible={accordionRubricState.trustSecurity} onClick={() => handleAccordionRubricChange('trustSecurity')}>
            <StyledAccordion
              title="Comment les annonces sont-elles contrôlées et quels réflexes adopter pour éviter les arnaques ?"
              visible={accordionState.fakeClassified}
              onClick={() => handleAccordionChange('fakeClassified')}
            >
              <AccordionContent>
                <p>Nous mettons en place des outils automatisés pour détecter les annonces suspectes avant leur mise en ligne.</p>
                <p>
                  Cependant, en tant que plateforme d&apos;hébergement, nous ne pouvons pas tout vérifier avant publication : les contenus restent sous la responsabilité des
                  annonceurs et nous n&apos;intervenons pas dans le cadre de vos échanges avec ces derniers.
                </p>
                <p>
                  Si vous repérez une annonce douteuse, n&apos;hésitez pas à utiliser notre outil de signalement en cliquant sur le lien « Signaler cette annonce » qui se trouve à
                  la fin de chaque annonce. Chaque signalement est pris en compte avec attention.
                </p>
                <p>
                  Par ailleurs, soucieux de préserver votre sérénité, nous mettons à votre disposition quelques conseils utiles pour éviter les arnaques, comme ne pas verser de
                  somme d&apos;argent ou ne pas communiquer de documents en amont d&apos;une visite :{' '}
                  <a href="https://edito.seloger.com/conseils-d-experts/louer/annonces-immobilieres-comment-eviter-les-arnaques-article-9685.html">Cliquez ici</a>
                </p>
                <p>
                  Voici également un guide de la location réalisé par la Direction Générale de la Concurrence, de la Consommation et de la Répression des Fraudes (DGCCRF) :{' '}
                  <a href="https://www.economie.gouv.fr/files/directions_services/dgccrf/documentation/publications/depliants/anciens_depliants/louer_logement.pdf">Cliquez ici</a>.
                </p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion title="Comment signaler une annonce frauduleuse ?" visible={accordionState.signalClassified} onClick={() => handleAccordionChange('signalClassified')}>
              <AccordionContent>
                <p>
                  Nous vous invitons à signaler toute annonce que vous estimez frauduleuse directement sur la page de l&apos;annonce concernée en utilisant le formulaire de
                  signalement prévu à cet effet, en cliquant sur le lien « Signaler cette annonce » qui se trouve à la fin de chaque annonce.
                </p>
                <img width="35%" src={PICTURES.signalClassified} alt="" title="" />
                <p>
                  L&apos;utilisation de cette procédure est le moyen le plus simple, le plus efficace et le plus rapide pour notifier un contenu que vous estimez frauduleux et
                  permet d&apos;éviter toute erreur d&apos;identification relative aux annonces publiées sur notre plateforme.
                </p>
                <p>Votre signalement sera pris en charge dans les plus brefs délais.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Que faire si mon numéro de téléphone apparaît sur une annonce alors que je n'ai pas publié l'annonce ?"
              visible={accordionState.fakePhone}
              onClick={() => handleAccordionChange('fakePhone')}
            >
              <AccordionContent>
                <p>
                  Si votre numéro de téléphone apparaît sur une annonce que vous n&apos;avez pas publiée, nous vous recommandons de vous rapprocher directement du propriétaire ou
                  de l&apos;agence concernée, responsables du contenu qu&apos;ils publient sur notre plateforme.
                </p>
                <p>
                  Vous pouvez également nous contacter via le formulaire de contact{' '}
                  <LinkButton
                    onClick={() => {
                      handleAnchor(5)
                    }}
                  >
                    https://www.seloger.com/contact.html
                  </LinkButton>{' '}
                  en nous fournissant toutes les informations nécessaires (lien de l&apos;annonce, numéro de téléphone concerné, etc.).
                </p>
                <p>Cela nous permettra de vérifier la situation et de prendre les mesures appropriées pour résoudre ce problème.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Que faire si mon bien est diffusé sur SeLoger sans autorisation ?"
              visible={accordionState.noPermission}
              onClick={() => handleAccordionChange('noPermission')}
            >
              <AccordionContent>
                <p>
                  Si vous constatez que votre bien est diffusé sur SeLoger sans avoir donné de mandat à l&apos;agence, nous vous recommandons de vous rapprocher directement de
                  l&apos;agence concernée, responsable du contenu qu&apos;elle publie sur notre plateforme.
                </p>
                <p>L&apos;agence pourra clarifier la situation et retirer l&apos;annonce si nécessaire.</p>
                <p>Veuillez noter que SeLoger n&apos;intervient pas dans le cadre de vos échanges avec les annonceurs.</p>
                <p>
                  Vous pouvez également nous contacter via le formulaire de contact{' '}
                  <LinkButton
                    onClick={() => {
                      handleAnchor(5)
                    }}
                  >
                    https://www.seloger.com/contact.html
                  </LinkButton>{' '}
                  en nous fournissant toutes les informations nécessaires (lien de l&apos;annonce, etc.).
                </p>
                <p>Cela nous permettra de vérifier la situation et de prendre les mesures appropriées pour résoudre ce problème.</p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Le diagnostic de performance énergétique (DPE) n'est pas renseigné sur une annonce"
              visible={accordionState.noDPE}
              onClick={() => handleAccordionChange('noDPE')}
            >
              <AccordionContent>
                <p>
                  Pour rappel, toute annonce immobilière doit, en principe, inclure les informations liées au DPE, à savoir la classe énergétique et l&apos;impact en termes
                  d&apos;émissions de gaz à effet de serre.
                </p>
                <p>
                  Toutefois, certaines exceptions peuvent s&apos;appliquer, par exemple pour des biens non soumis à l&apos;obligation de DPE (comme les biens à usage temporaire ou
                  les bâtiments classés monuments historiques).
                </p>
                <p>En outre, pour les biens classés G+ et G, la location est en principe interdite, sauf exceptions légales.</p>
                <p>
                  Si le DPE n&apos;est pas renseigné sur une annonce, nous vous recommandons de vous rapprocher directement du propriétaire ou de l&apos;agence en charge du bien.
                  Ils pourront vous fournir les informations nécessaires concernant le diagnostic énergétique du logement.
                </p>
                <p>
                  Si vous considérez que l&apos;annonce n&apos;est pas conforme à la réglementation en vigueur concernant le DPE, vous pouvez également la signaler en utilisant le
                  formulaire de signalement prévu à cet effet. Notre service de modération examinera votre signalement dans les meilleurs délais.
                </p>
              </AccordionContent>
              <div className="withSeparator" />
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
          </StyledAccordion>
          <StyledAccordion title="ANNONCES" visible={accordionRubricState.classified} onClick={() => handleAccordionRubricChange('classified')}>
            <StyledAccordion title="Comment publier, modifier ou supprimer une annonce ?" visible={accordionState.publish} onClick={() => handleAccordionChange('publish')}>
              <AccordionContent>
                <StyledTitle>Publier une annonce</StyledTitle>
                <p>
                  Particuliers, SeLoger vous permet de <a href="//www.seloger.com/depot-annonce/?page=proprietaire">diffuser votre annonce de location ou de vente</a> par
                  vous-m&ecirc;mes ou accompagn&eacute;s d&apos;une s&eacute;lection de professionnels.
                </p>
              </AccordionContent>
              <AccordionContent>
                <StyledTitle>Modifier ou supprimer une annonce</StyledTitle>
                <p>
                  Vous pouvez modifier ou supprimer une annonce que vous avez mis en ligne directement depuis{' '}
                  <a href="//www.seloger.com/mes-annonces">votre espace propri&eacute;taire.</a>
                </p>
              </AccordionContent>
              <div className="withSeparator">
                <AccordionContent>
                  <StyledTitle>Annonce refus&eacute;e</StyledTitle>
                  <ul>
                    <li>
                      Votre annonce de vente a &eacute;t&eacute; refus&eacute;e ? Consultez{' '}
                      <a href="//static-seloger.com/commons/fsbo/regles-de-diffusion-20230512.pdf">nos crit&egrave;res de diffusion</a> avant d&rsquo;en cr&eacute;er une nouvelle.
                    </li>
                    <li>
                      Votre annonce de location a &eacute;t&eacute; refus&eacute;e ? Consultez{' '}
                      <a href="//static-seloger.com/commons/fsbo/CGS-location-particulier-20230623.pdf">nos crit&egrave;res de diffusion</a> avant d&rsquo;en cr&eacute;er une
                      nouvelle.
                    </li>
                  </ul>
                </AccordionContent>
              </div>
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(5)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
            <StyledAccordion
              title="Où trouver un professionnel de l’immobilier pour mon bien ?"
              visible={accordionState.professional}
              onClick={() => handleAccordionChange('professional')}
            >
              <AccordionContent>
                <StyledTitle>SeLoger privil&eacute;gie l&rsquo;expertise d&rsquo;un professionnel pour la r&eacute;alisation de vos projets immobiliers </StyledTitle>
                <p>
                  Vous pouvez acc&eacute;der à notre <a href="//www.seloger.com/annuaire/?#m=header-vendre-annuaire">annuaire des professionnels</a> afin de trouver le meilleur
                  agent pour vous accompagner dans votre projet. Vous pouvez &eacute;galement{' '}
                  <a href="//www.seloger.com/estimation-immobiliere.html#?m=header-acheter-estimation_immo">faire une première estimation</a> de votre bien en ligne.
                </p>
              </AccordionContent>
              <ContactUsContent>
                <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
                <LinkButton
                  onClick={() => {
                    handleAnchor(4)
                  }}
                >
                  Non, contactez nous
                </LinkButton>
              </ContactUsContent>
            </StyledAccordion>
          </StyledAccordion>
        </MainContainer>
        <MainContainer>
          <h2>Professionnels</h2>
          <StyledAccordion title="Comment publier, modifier ou supprimer une annonce ?" visible={accordionState.proPublish} onClick={() => handleAccordionChange('proPublish')}>
            <div className="withSeparator">
              <AccordionContent>
                <p>
                  Retrouvez toutes nos offres sur notre <a href="//pro-seloger.com/">site d&eacute;di&eacute; aux professionnels</a>.
                </p>
              </AccordionContent>
            </div>
            <ContactUsContent>
              <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
              <LinkButton
                onClick={() => {
                  handleAnchor(11)
                }}
              >
                Non, contactez nous
              </LinkButton>
            </ContactUsContent>
          </StyledAccordion>
          <StyledAccordion title="Régie publicitaire" visible={accordionState.advert} onClick={() => handleAccordionChange('advert')}>
            <div className="withSeparator">
              <AccordionContent>
                <StyledTitle>SeLoger la r&eacute;gie, vous propose :</StyledTitle>
                <ul>
                  <li>Des formats publicitaires natifs et display IAB (Habillage, bannières, pav&eacute;s, ...) </li>
                  <li>Le sponsoring d&rsquo;une partie du r&eacute;dactionnel</li>
                  <li>Le sponsoring de newsletter</li>
                  <li>La possibilit&eacute; de ciblage :</li>
                  <ul>
                    <li>par type de recherche</li>
                    <li>par rubrique</li>
                    <li>par critères socio-d&eacute;mographiques et g&eacute;ographiques.</li>
                  </ul>
                </ul>
                <LogoRegie>
                  <a href="//regie.seloger.com">
                    <img height="50" src="/ser/img/seloger_regie_v2.png" alt="Publicité sur SeLoger.com" title="Publicité sur SeLoger.com" />
                  </a>
                </LogoRegie>
                <SliceRegie>
                  Chacune de vos campagnes est servie et certifi&eacute;e par notre r&eacute;gie. Pour plus d&rsquo;informations,{' '}
                  <a href="https://www.seloger-publicite.com/" rel="noopener noreferrer" target="_blank">
                    contactez nous ici
                  </a>
                  .
                </SliceRegie>
              </AccordionContent>
            </div>
            <ContactUsContent>
              <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
              <LinkButton
                onClick={() => {
                  handleAnchor(10)
                }}
              >
                Non, contactez nous
              </LinkButton>
            </ContactUsContent>
          </StyledAccordion>
          <StyledAccordion title="Espace presse" visible={accordionState.media} onClick={() => handleAccordionChange('media')}>
            <div className="withSeparator">
              <AccordionContent>
                <p>
                  Retrouvez nos derniers communiqu&eacute;s et les coordonn&eacute;es de notre service presse <a href="https://www.seloger-publicite.com/">ici</a>.
                </p>
              </AccordionContent>
            </div>
            <ContactUsContent>
              <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
              <LinkButton
                onClick={() => {
                  handleAnchor(9)
                }}
              >
                Non, contactez nous
              </LinkButton>
            </ContactUsContent>
          </StyledAccordion>
          <StyledAccordion title="Equipe éditoriale" visible={accordionState.editorial} onClick={() => handleAccordionChange('editorial')}>
            <div className="withSeparator">
              <AccordionContent>
                <p>
                  Vous souhaitez contacter la r&eacute;daction ? Retrouvez nos r&eacute;dacteurs sur leur <a href="//edito.seloger.com/redaction-seloger-page-1309.html">page</a> .
                  <br />
                  <b>R&eacute;dacteur en chef :</b> Xavier Beaunieux
                </p>
                <p />
              </AccordionContent>
            </div>
            <ContactUsContent>
              <StyledTitle>Avez-vous trouv&eacute; la r&eacute;ponse à votre question ?</StyledTitle>
              <LinkButton
                onClick={() => {
                  handleAnchor(9)
                }}
              >
                Non, contactez nous
              </LinkButton>
            </ContactUsContent>
          </StyledAccordion>
        </MainContainer>

        {formulaireContactState && (
          <FormulaireContact>
            <StyledH2>Contacter le service client de SeLoger</StyledH2>

            <StyledH3>
              <FormulaireContactH3>Vous souhaitez obtenir plus d&rsquo;informations sur une annonce ou demander une visite ?</FormulaireContactH3>
              <p>
                <img height="20" src="/ser/img/main_direction.png" alt="" title="" />
                Contactez l&rsquo;agence ou le propri&eacute;taire via les coordonn&eacute;es affich&eacute;es sur les pages annonces
              </p>
            </StyledH3>

            <StyledH3>
              <FormulaireContactH3>Pour toute autre demande concernant le site internet ou l&rsquo;application SeLoger...</FormulaireContactH3>
              <p>
                <img height="20" src="/ser/img/main_ecrit.png" alt="" title="" />
                Utilisez le formulaire de contact suivant :
              </p>
            </StyledH3>
            <div id="msg-placeholder" />

            {bannerMessage && <ErrorMessage>{bannerMessage.message}</ErrorMessage>}
            {successMessage ? (
              <>
                <SuccessMessage>
                  <div>{successMessage.message}</div>
                  <Button onClick={handleDisplayForm} iconPosition="left" kind="primary" size="large" variant="normal">
                    Envoyer un autre message
                  </Button>
                </SuccessMessage>
              </>
            ) : (
              <>
                <FormGrid ref={formRef}>
                  <TextField onChange={handleChange} name="name" iconColor="#262626" value={formState.name} placeholder="Nom *" className="form-input" />
                  <TextField onChange={handleChange} name="email" iconColor="#262626" value={formState.email} placeholder="Adresse mail *" className="form-input" />
                  <Dropdown
                    onSelect={handleSelect}
                    className="form-input"
                    defaultLabel="Sujet *"
                    value={formState.subjectElement}
                    list={[
                      {
                        key: '100',
                        list: websiteSelectList,
                        title: 'A propos du site',
                      },
                      {
                        key: '200',
                        list: professionalSelectList,
                        title: 'Professionnels',
                      },
                    ]}
                  />

                  <StyledTextArea
                    onChange={handleChange}
                    name="description"
                    placeholder="Votre message *"
                    value={formState.description}
                    style={{ height: '100%', minWidth: '100%' }}
                  />
                </FormGrid>
                <FormButtonContainer>
                  <Button disabled={disabled} onClick={handleSendMessage} iconPosition="left" kind="primary" size="large" variant="normal">
                    Envoyer mon message
                  </Button>
                </FormButtonContainer>
              </>
            )}

            <RequiredInfo>
              ( * ) Champs obligatoires. Digital Classifieds France procède au traitement de vos donn&eacute;es afin de g&eacute;rer votre demande. Pour en savoir plus et exercer
              vos droits,{' '}
              <LinkButton className="formButton" onClick={handleClickHere}>
                cliquez ici
              </LinkButton>
              .
            </RequiredInfo>
            {showMore && (
              <RequiredInfo>
                Ces donn&eacute;es pourront être transmises aux soci&eacute;t&eacute;s du{' '}
                <a href="https://www.aviv-group.com/companies" rel="noopener noreferrer" target="_blank">
                  Groupe AVIV
                </a>{' '}
                auquel nous appartenons. Pour exercer vos droits sur vos donn&eacute;es (accès, rectification, effacement, opposition, portabilit&eacute; et limitation),
                contactez-nous à cette adresse : Digital Classifieds France - 65 Rue Ordener, 75880 Paris Cedex 18 ou via ce formulaire. Pour plus d’informations, consultez notre{' '}
                <a href="//www.seloger.com/CGU_politique_de_confidentialite.html">Politique de Confidentialit&eacute;.</a>
              </RequiredInfo>
            )}
          </FormulaireContact>
        )}
      </Wrapper>
    </Main>
  )
}

export default hot(module)(Contact)
